<template>
    <div class="h-full">
        <div id="map_component" class="h-full"></div>
    </div>
</template>

<script>
    import { Loader } from "@googlemaps/js-api-loader";

    export default {
        props: ['latitude', 'longitude', 'zoom'],

        data() {
            return {
                loader: null,
                map: null,
                rotation: 0,
            }
        },

        mounted() {
            this.loader = new Loader({
              apiKey: import.meta.env.VITE_GOOGLE_MAPS_API_KEY,
              version: "quarterly"
            });

            this.loader.load().then(async () => {
              const { Map } = await google.maps.importLibrary("maps");

              this.map = new Map(document.getElementById("map_component"), {
                center: { lat: this.latitude, lng: this.longitude },
                zoom: this.zoom,
                mapId: "REOPTIMIZER_REATLAS_V2",
              });

              this.$nextTick(() => this.addMarker());
            });
        },

        methods: {
            async addMarker() {
                const { AdvancedMarkerElement } = await google.maps.importLibrary("marker");

                let icon = document.createElement("img");
                icon.src = '/img/map/marker-site.png';

                new AdvancedMarkerElement({
                    map: this.map,
                    position: { lat: this.latitude, lng: this.longitude },
                    content: icon,
                });
            }
        }
    }
</script>
